<!-- 企业认证 -->
<template>
	<div style="width: 700px;">
		<div style="font-size: 16px;color: #767794;margin-top: 40px;">
			请填写企业及个人基本信息
		</div>
		<el-form class="custom-form" :model="form" label-width="80px" label-position="top" :rules="rules"
			ref="authForm">
			<el-form-item label="公司全称" prop="company_name" required>
				<el-select v-model="form.company_name" filterable remote reserve-keyword placeholder="请输入企业全称"
					:remote-method="handleSearch" :loading="loading" @change="handleSelect" style="width: 100%;">
					<el-option v-for="item in options" :key="item.company_name" :label="item.company_name"
						:value="item.company_name"></el-option>
				</el-select>
				<!-- <el-input v-model="form.companyName" placeholder="请输入企业全称" @input="onInput"></el-input> -->
			</el-form-item>
			<el-form-item label="职位" prop="position" required>
				<el-input v-model="form.position" placeholder="请输入您在公司的职位"></el-input>
			</el-form-item>
			<el-form-item label="姓名" prop="name" required>
				<el-input v-model="form.name" placeholder="请输入您的真实姓名"></el-input>
			</el-form-item>
			<el-form-item label="身份证号" prop="idCard" required>
				<el-input v-model="form.idCard" placeholder="请输入您的身份证号"></el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button 
				class="next-btn" 
				:class="{ 'next-btn-active': isFormComplete }"
				type="primary" 
				@click="handleNext"
			>
				下一步
			</el-button>
		</div>
		<!-- <div class="flex-row" style="width: 100%; justify-content: space-around">
      <button class="submitButton">提交</button>
      <router-link to="/store/entry/loginEmail">
        <button class="submitButton">返回</button>
      </router-link>
    </div> -->
		
		<!-- 二维码弹窗 -->
		<el-dialog
			title="人脸认证"
			:visible.sync="qrDialogVisible"
			width="400px"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:show-close="false"
			:modal="false"
			center
			class="qr-dialog"
		>
			<div class="qr-dialog-content">
				<div class="qr-status-text" v-if="scanStatus === 0">请使用手机扫描二维码进行人脸认证</div>
				<div class="qr-status-text" v-else-if="scanStatus === 1">认证处理中，请稍候...</div>
				<div class="qr-status-text success" v-else-if="scanStatus === 2">认证成功！</div>
				<div class="qr-status-text error" v-else-if="scanStatus === 3">认证失败，请重试</div>
				<div class="qr-status-text error" v-else-if="scanStatus === 4">二维码已过期，请重新生成</div>
				
				<div class="qr-image-container" v-if="faceImage && scanStatus !== 2 && scanStatus !== 3 && scanStatus !== 4">
					<img :src="faceImage" alt="人脸认证二维码" class="qr-image" />
				</div>
				
				<div class="qr-actions" v-if="scanStatus === 3 || scanStatus === 4">
					<el-button type="primary" @click="handleRegenerateQR">重新生成二维码</el-button>
					<el-button @click="handleCloseQR">关闭</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import {
		getQuery
	} from '@/api/businessVerification'
	import { confirmCompanyAndInitFace, queryFaceVerificationResult, bindCompanyInfo,queryFaceScanStatus  } from '@/api/verify'
	export default {
		data() {
			// 自定义身份证号验证规则
			const validateIdCard = (rule, value, callback) => {
				// 简单的18位身份证号正则校验
				const reg = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
				if (!value) {
					return callback(new Error("请输入身份证号"));
				} else if (!reg.test(value)) {
					return callback(new Error("请输入正确的18位身份证号"));
				} else {
					callback();
				}
			};

			return {
				options: [],
				loading: false,
				allOptions: [ // 所有可选数据
					{
						eid: 1,
						company_name: '绿藤集团'
					},
					{
						eid: 2,
						company_name: '强盛集团'
					},
				],
				form: {
					company_name: "",
					position: "",
					name: "",
					idCard: "",
				},
				certifyId: '',
				pollingTimer: null,
				qrDialogVisible: false, // 二维码弹窗显示状态
				faceImage: '', // 二维码图片
				scanStatus: 0, // 扫码状态：0待扫码、1处理中、2成功、3失败、4过期
				pollingInterval: null, // 轮询定时器
				// 验证规则配置
				rules: {
					company_name: [{
							required: true,
							message: "请输入公司全称",
							trigger: "blur"
						},
						{
							min: 2,
							max: 50,
							message: "公司名称长度在2-50个字符之间",
							trigger: "blur",
						},
					],
					position: [{
							required: true,
							message: "请输入职位",
							trigger: "blur"
						},
						{
							min: 1,
							max: 20,
							message: "职位长度在1-20个字符之间",
							trigger: "blur",
						},
					],
					name: [{
							required: true,
							message: "请输入姓名",
							trigger: "blur"
						},
						{
							min: 2,
							max: 10,
							message: "姓名长度在2-10个字符之间",
							trigger: "blur",
						},
					],
					idCard: [{
						required: true,
						validator: validateIdCard,
						trigger: "blur"
					}],
				},
			};
		},
		computed: {
			isFormComplete() {
				return this.form.company_name && 
					   this.form.position && 
					   this.form.name && 
					   this.form.idCard;
			}
		},
		mounted() {
			// 优先尝试从本地恢复发起核身时保存的信息，防止新开窗口回调参数缺失
			try {
				const storedInfo = localStorage.getItem('companyVerifyInfo');
				if (storedInfo) {
					const parsed = JSON.parse(storedInfo);
					this.certifyId = parsed.certifyId || this.certifyId;
					// 合并回填表单，避免丢失用户输入
					if (parsed.formData) {
						this.form = { ...this.form, ...parsed.formData };
					}
				}
			} catch (e) {
				console.warn('恢复本地公司核身信息失败:', e);
			}

			// 处理人脸核身回调（保留兼容性，但主要使用二维码方式）
			const params = new URLSearchParams(window.location.search);
			const encoded = params.get('response');
			if (!encoded) return;
			try {
				const decoded = decodeURIComponent(encoded);
				const res = JSON.parse(decoded);
				const { code, subCode, reason, certifyId, status } = res;
				if (status === 'SUCCESS' && code === 1000) {
					// 成功，直接查询并绑定
					this.certifyId = certifyId || this.certifyId;
					this.checkFaceResultOnce(this.certifyId);
					return;
				}
				if (code === 1000 || (code === 2006 && subCode === 'H5057')) {
					// 优先使用本地持久化的 certifyId，避免回调缺参
					this.checkFaceResultOnce(this.certifyId || certifyId);
				} else if (code === 1003) {
					this.$message.error(reason || '验证失败');
				}
			} catch (e) {
				console.error(e);
				this.$message.error('解析回调参数失败');
			}
		},
		beforeDestroy() {
			// 组件销毁时清理轮询
			this.stopPolling();
		},
		methods: {
			handleSearch(query) {
				if (!query) {
					this.options = [];
					return;
				}
				this.loading = true;

				getQuery({
					name: query,
				}).then(async res => {
					console.log('API返回数据:', res.data.data); // 查看完整的返回数据
					if (res.data.code == 1) {
						this.options = res.data.data.filter(item => {
							console.log('过滤中的item:', item); // 查看每个item的值
							return item.company_name.toLowerCase().includes(query.toLowerCase())
						});
						console.log('最终options:', this.options); // 查看过滤后的结果
						this.loading = false;
					} else {
						this.loading = false;
					}
				})
			},
			handleSelect(value) {
				console.log('选中的值:', value);
				// 如果需要查看完整的item对象，可以根据value从options中查找
				const selectedItem = this.options.find(item => item.company_name === value);
				console.log('选中的完整item:', selectedItem);
			},
			handleNext() {
				// 触发表单验证
				this.$refs.authForm.validate(async (valid) => {
					if (!valid) {
						console.log("表单验证失败");
						return false;
					}
					try {
						// 初始化人脸核身
						const { data } = await confirmCompanyAndInitFace({
							company_name: this.form.company_name,
							cert_name: this.form.name,
							cert_no: this.form.idCard
						});
						if (!data || data.code !== 1 || !data.data || !data.data.certify_id) {
							this.$message.error(data?.msg || '初始化失败');
							return;
						}
						this.certifyId = data.data.certify_id;
						// 保存必要信息以便回调后使用
						localStorage.setItem('companyVerifyInfo', JSON.stringify({
							certifyId: this.certifyId,
							companyName: this.form.company_name,
							formData: this.form
						}));
						
						// 获取二维码图片
						if (data.data.qr_code) {
							this.faceImage = data.data.qr_code;
							this.scanStatus = 0; // 待扫码
							this.qrDialogVisible = true;
							// 开始轮询
							this.startPolling();
						} else {
							this.$message.error('未获取到二维码图片');
						}
					} catch (e) {
						console.error(e);
						this.$message.error(e?.msg || '初始化失败');
					}
				});
			},
			async checkFaceResultOnce(certifyId) {
				try {
					if (!certifyId) {
						this.$message.error('认证ID缺失');
						return;
					}
					const { data } = await queryFaceVerificationResult({ certifyId });
					const isSuccess = data.data?.certify_state === 'SUCCESS' || data.data?.status === 'SUCCESS' || data.status === 'SUCCESS' || data.code === 1000;
					if (isSuccess) {
						// await this.bindCompany();
						this.$router.push({
							path: '/verifyCompany/businessVerificationFunc',
							query: { form: JSON.stringify(this.form) }
						});
					} else {
						this.$message.error('人脸核身失败');
					}
				} catch (e) {
					console.error(e);
					this.$message.error(e?.msg || '结果查询失败');
				}
			},
			// 开始轮询扫码状态
			startPolling() {
				// 清除之前的轮询
				this.stopPolling();
				// 立即执行一次
				this.pollFaceScanStatus();
				// 每2秒轮询一次
				this.pollingInterval = setInterval(() => {
					this.pollFaceScanStatus();
				}, 3000);
			},
			// 停止轮询
			stopPolling() {
				if (this.pollingInterval) {
					clearInterval(this.pollingInterval);
					this.pollingInterval = null;
				}
			},
			// 轮询查询扫码状态
			async pollFaceScanStatus() {
				if (!this.certifyId) {
					this.stopPolling();
					return;
				}
				try {
					const { data } = await queryFaceScanStatus({ certifyId: this.certifyId });
					if (data && data.code === 1 && data.data) {
						const status = data.data.status;
						this.scanStatus = status;
						
						// 根据状态处理
						if (status === 2) {
							// 成功
							this.stopPolling();
							this.$message.success('人脸认证成功！');
							setTimeout(() => {
								this.qrDialogVisible = false;
								// 跳转到下一步
								this.$router.push({
									path: '/verifyCompany/businessVerificationFunc',
									query: { form: JSON.stringify(this.form) }
								});
							}, 1500);
						} else if (status === 3) {
							// 失败
							this.stopPolling();
							this.$message.error(data.data.message || '人脸认证失败');
						} else if (status === 4) {
							// 过期
							this.stopPolling();
							this.$message.warning('二维码已过期，请重新生成');
						}
						// status === 0 (待扫码) 或 status === 1 (处理中) 继续轮询
					} else {
						console.error('查询扫码状态失败:', data);
					}
				} catch (e) {
					console.error('轮询扫码状态异常:', e);
					// 轮询异常时不停止，继续尝试
				}
			},
			// 重新生成二维码
			handleRegenerateQR() {
				this.handleNext();
			},
			// 关闭二维码弹窗
			handleCloseQR() {
				this.stopPolling();
				this.qrDialogVisible = false;
				this.scanStatus = 0;
				this.faceImage = '';
			},
		},
	};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
	::v-deep .el-input-group__append {
		border-radius: 0px 18px 18px 0px;
		font-size: large;
	}

	::v-deep .el-input-group__prepend {
		border-radius: 18px 0px 0px 18px;
		font-size: x-large;
	}

	::v-deep .el-input__inner {
		height: 60px;
		font-size: large;
		border-radius: 18px;
	}

	::v-deep .phone .el-input__inner {
		border-radius: 0px;
	}

	.submitButton {
		width: 180px;
		height: 50px;
		border-radius: 18px;
		background-image: linear-gradient(90deg,
				rgba(126, 180, 235, 1) 0,
				rgba(177, 110, 249, 1) 100%);
		color: white;
		margin-top: 20px;
		font-size: x-large;
		cursor: pointer;
	}

	/* 自定义表单样式 - 字体变大加粗 */
	::v-deep .custom-form {
		/* 调整整体表单的字体大小 */
		font-size: 18px;
		margin-top: 10px;
	}

	/* 表单项标签样式 */
	::v-deep .custom-form .el-form-item__label {
		font-weight: bold;
		/* 标签加粗 */
		font-size: 18px;
		/* 标签字体稍大于输入框 */
		color: #333;
		/* 加深标签颜色 */
	}

	/* 输入框内容样式 */
	::v-deep .custom-form .el-input__inner {
		font-size: 18px;
		/* 输入框字体大小 */
		padding: 10px 15px;
		/* 加大输入框内边距，让整体更大气 */
	}

	.next-btn {
		width: 100%;
		height: 40px;
		background-color: #c6c6c6;
		border: transparent;
		border-radius: 10px;
		transition: all 0.3s ease;
	}

	.next-btn-active {
		color: white !important;
		background-image: linear-gradient(90deg, rgba(126, 180, 235, 1) 0, rgba(177, 110, 249, 1) 100%) !important;
	}

	/* 二维码弹窗样式 */
	.qr-dialog-content {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 20px;
	}

	.qr-status-text {
		font-size: 16px;
		color: #333;
		margin-bottom: 20px;
		text-align: center;
	}

	.qr-status-text.success {
		color: #67c23a;
		font-weight: bold;
	}

	.qr-status-text.error {
		color: #f56c6c;
		font-weight: bold;
	}

	.qr-image-container {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 250px;
		height: 250px;
		background: #f5f5f5;
		border-radius: 12px;
		padding: 15px;
		margin-bottom: 20px;
	}

	.qr-image {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.qr-actions {
		display: flex;
		justify-content: center;
		gap: 15px;
		margin-top: 10px;
	}

	::v-deep .el-dialog__header {
		text-align: center;
		padding: 20px 20px 10px;
	}

	::v-deep .el-dialog__title {
		font-size: 18px;
		font-weight: bold;
	}

	::v-deep .el-dialog__body {
		padding: 10px 20px 20px;
	}


</style>